import { useRouteError } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export const AppErrorBoundary = () => {
  const error = useRouteError() as any;

  // Verifica se o erro é de módulo carregado dinamicamente (lazy load pattern falhando após um deploy)
  const isDynamicImportError =
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('error loading dynamically imported module') ||
    error?.message?.includes('Importing a module script failed');

  if (isDynamicImportError) {
    // Se for um erro de módulo que falhou devido a uma nova versão (hash diferente), forçamos um reload
    // Isso vai baixar a versão mais recente do index.html com os hashes corretos do novo deploy

    // Evita loop infinito de reload caso o erro persista
    const reloaded = sessionStorage.getItem('dynamicImportErrorReloaded');
    if (!reloaded) {
      sessionStorage.setItem('dynamicImportErrorReloaded', 'true');
      window.location.reload();
      return null;
    }
  } else {
    // Se não for erro de import ou de fato outra coisa, reseta a flag
    sessionStorage.removeItem('dynamicImportErrorReloaded');
  }

  // Fallback padrão para outros tipos de erros ou se o reload falhou
  return (
    <Container
      maxWidth="sm"
      sx={{ display: 'flex', alignItems: 'center', minHeight: '100vh', paddingY: 4 }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          width: '100%',
          borderRadius: 2,
        }}
      >
        <ErrorOutlineIcon color="error" sx={{ fontSize: 64, mb: 2 }} />
        <Typography variant="h5" component="h1" gutterBottom fontWeight="bold">
          Oops! Algo deu errado.
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Encontramos um erro inesperado ao tentar carregar esta página.
        </Typography>
        {import.meta.env.DEV && error?.message && (
          <Box
            sx={{
              mt: 2,
              mb: 3,
              p: 2,
              bgcolor: 'grey.100',
              borderRadius: 1,
              width: '100%',
              textAlign: 'left',
              overflowX: 'auto',
            }}
          >
            <Typography
              variant="body2"
              component="pre"
              color="error"
              sx={{ m: 0, fontFamily: 'monospace' }}
            >
              {error.message}
            </Typography>
          </Box>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={() => (window.location.href = '/')}
          sx={{ mt: 2 }}
        >
          Voltar para o Início
        </Button>
      </Paper>
    </Container>
  );
};
